import styled from 'styled-components';
import { MuiSelect } from 'theme/material-ui';

export const StyledSelect = styled(MuiSelect)`
  select {
    padding: 0px 32px 0px 7px;
  }
`;
